import React from 'react';
import styled from 'styled-components';

const PStyles = styled.div`
  max-width: 500px;
  margin: 0 auto;
  font-size: 1.8rem;
  line-height: 1.3em;
  .highlight {
    background: var(--deep-dark);
    font-weight: 700;
  }
  @media only screen and (max-width: 768px) {
    font-size: 1.4rem;
  } ;
`;

function PText({ children }) {
  return (
    <PStyles className="para">
      <p>
        <span className="highlight">{children}</span>
      </p>
    </PStyles>
  );
}

export default PText;
